import { render, staticRenderFns } from "./BookAddressSearch.vue?vue&type=template&id=94444bb8&"
import script from "./BookAddressSearch.vue?vue&type=script&lang=js&"
export * from "./BookAddressSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports